/*
 *
 * ComparativeAnalysis actions
 *
 */

import {
  GET_HEADERS_SUCCESS,
  GET_FILTERS_SUCCESS,
  GET_FILTERS_WATCHER,
  GET_DIVISIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_FAILED,
  GET_DIVISIONS_CHILDS_WATCHER,
  GET_INDICATOR_WATCHER,
  GET_INDICATOR_SUCCESS,
  GET_INDICATOR_FAILED,
  GET_MEASURE_WATCHER,
  GET_MEASURE_SUCCESS,
  GET_MEASURE_FAILED,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MEASURE_INFO_SEGMENT_SUCCESS,
  GET_MEASURE_INFO_SEGMENT_FAILED,
  GET_MEASURE_INFO_SEGMENT_WATCHER,
  GET_DIVISIONS_ROWS_SUCCESS,
  GET_DIVISIONS_ROWS_WATCHER,
} from "./constants"

export function getHeadersSuccess(payload) {
  return {
    type: GET_HEADERS_SUCCESS,
    payload,
  }
}

export function getFiltersWatcher(payload) {
  return {
    type: GET_FILTERS_WATCHER,
    payload,
  }
}

export function getFiltersSuccess(payload) {
  return {
    type: GET_FILTERS_SUCCESS,
    payload,
  }
}

export function getDivisionsWatcher(payload) {
  return {
    type: GET_DIVISIONS_WATCHER,
    payload,
  }
}

export function getDivisionsSuccess(payload) {
  return {
    type: GET_DIVISIONS_SUCCESS,
    payload,
  }
}

export function getDivisionsRowsWatcher(payload) {
  return {
    type: GET_DIVISIONS_ROWS_WATCHER,
    payload,
  }
}

export function getDivisionsRowsSuccess(payload) {
  return {
    type: GET_DIVISIONS_ROWS_SUCCESS,
    payload
  }
}

export function getDivisionsFailed() {
  return { type: GET_DIVISIONS_FAILED }
}

export function getDivisionsChildsWatcher(payload) {
  return {
    type: GET_DIVISIONS_CHILDS_WATCHER,
    payload,
  }
}

export function getIndicatorWatcher(payload) {
  return {
    type: GET_INDICATOR_WATCHER,
    payload,
  }
}

export function getIndicatorSuccess(payload) {
  return {
    type: GET_INDICATOR_SUCCESS,
    payload,
  }
}

export function getIndicatorFailed() {
  return { type: GET_INDICATOR_FAILED }
}

export function getMeasureWatcher(payload) {
  return {
    type: GET_MEASURE_WATCHER,
    payload,
  }
}

export function getMeasureSuccess(payload) {
  return {
    type: GET_MEASURE_SUCCESS,
    payload,
  }
}

export function getMeasureFailed() {
  return { type: GET_MEASURE_FAILED }
}

/* MEASURE RANGE COLOR */
export function getMeasureColorRangeWatcher(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_WATCHER,
    payload,
  }
}

export function getMeasureColorRangeSuccess(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_SUCCESS,
    payload,
  }
}

export function getMeasureInfoSegmentSuccess(payload) {
  return {
    type: GET_MEASURE_INFO_SEGMENT_SUCCESS,
    payload,
  }
}

export function getMeasureInfoSegmentFailed() {
  return {
    type: GET_MEASURE_INFO_SEGMENT_FAILED,
  }
}

export function getMeasureInfoSegmentWatcher(payload) {
  return {
    type: GET_MEASURE_INFO_SEGMENT_WATCHER,
    payload,
  }
}
